/* global */
import './style.less';
import { uniq, orderBy } from 'lodash';
import JSZip from 'jszip';
import JSZipUtils from 'jszip-utils';

export default function($log, $sce, $stateParams, $window, $q, $filter, Swal) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;

  vm.itemsPerPage = 20;

  vm.selectAll = false;
  vm.filteredAttachments = [];
  vm.attachments = [];
  vm.selectedAttachments = [];
  vm.selectedCount = 0;

  vm.onFilter = function(stCtrl) {
    vm.filteredAttachments = stCtrl.getFilteredCollection();
  };

  vm.updateSelected = function() {
    vm.selectedAttachments = vm.attachments.filter(({ selected }) => selected);
    vm.selectedCount = vm.selectedAttachments.length;
  };

  vm.onClickSelectAll = function(selectAll) {
    vm.filteredAttachments.forEach(user => (user.selected = selectAll));
    vm.updateSelected();
  };

  vm.downloadFiles = () => {
    const zip = new JSZip();
    const timeStamp = `?time=${new Date().getTime()}`;

    const promises = vm.selectedAttachments.map(({ url, name, first, last }) => {
      return $q(resolve => {
        JSZipUtils.getBinaryContent(`${url}${timeStamp}`, (error, data) => {
          if (error) return resolve('NO FILE');
          const fileName = `${first}-${last}-${name}`;
          zip.file(fileName, data, { binary: true });
          resolve('FILE FOUND');
        });
      });
    });

    $q.all(promises)
      .then(() => zip.generateAsync({ type: 'blob' }))
      .then(content => {
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(content);
        downloadLink.download = 'ProlaeraAttachments.zip';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.success = () => {
    Swal.toast('Copied');
  };

  vm.fail = error => {
    $log.error(error);
    throw error;
  };

  vm.open = url => $window.open(url, 'popup', 'width=750,height=500,left=10,top=150');

  function activate() {
    $log.debug('Attachments Activated');

    const profile_uid = $stateParams.employeeID || $stateParams.id;
    vm.profile_uid = profile_uid;

    const attachments = vm.ngModel.map(attachment => {
      const { name } = attachment;

      if (name.includes('.') && name.split('.').pop()) {
        attachment.extension = `.${name.split('.').pop()}`;
      }

      return attachment;
    });

    vm.attachments = orderBy(attachments, ['LastModified', 'name'], ['desc', 'asc']);
    vm.typesGroup = uniq(attachments.map(({ type }) => type));
    vm.extensionsGroup = uniq(attachments.filter(({ extension }) => extension).map(({ extension }) => extension));
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tables/attachments/controller.js